// Test IDs for the main dashboard layout (sidebar, header, coming-soon pages).

export const LAYOUT = {
        sidebarNavPrefix: 'sidebar-nav-', // e.g. sidebar-nav-dashboard
        sidebarMobileToggle: 'sidebar-mobile-toggle',
        headerUserMenuTrigger: 'header-user-menu-trigger',
        headerProfileLink: 'header-profile-link',
        headerLogoutButton: 'header-logout-button',
        headerClinicName: 'header-clinic-name',
        comingSoonBadge: 'coming-soon-badge',
        conversationsAttentionBadge: 'sidebar-conversations-attention-badge',
        enableChatNotifications: 'sidebar-enable-chat-notifications',
        agendaOnlineBadge: 'sidebar-agenda-online-badge', // Fix AR (2026-10-27)
};
